import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type PrepaidExpenseModalState = {
  isOpen: boolean;
  transactionId: string | null;
};

const initialState: PrepaidExpenseModalState = {
  isOpen: false,
  transactionId: null,
};

export const prepaidExpenseModalSlice = createSlice({
  name: "prepaidExpenseModal",
  initialState,
  reducers: {
    openPrepaidExpenseModal: (state, action: PayloadAction<string>) => {
      state.isOpen = true;
      state.transactionId = action.payload;
    },
    closePrepaidExpenseModal: (state) => {
      state.isOpen = false;
      state.transactionId = null;
    },
  },
});

export const { openPrepaidExpenseModal, closePrepaidExpenseModal } =
  prepaidExpenseModalSlice.actions;

export default prepaidExpenseModalSlice.reducer;
